// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1syMZ","right":"styles_right__1_lwH"};